// extracted by mini-css-extract-plugin
export default {"container":"style_container__H2yiN","center":"style_center__brPgi"};